import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/android-chrome-192x192.png';

function Navbar() {
  const [searchQuery, setSearchQuery] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('userToken'));
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setMenuOpen(false);
    }
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen(prevState => !prevState);
  };

  const closeMenu = () => setMenuOpen(false);

  const handleClickOutside = useCallback((event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target) &&
      menuOpen
    ) {
      setMenuOpen(false);
    }
  }, [menuOpen]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    const handleStorage = () => {
      setIsLoggedIn(!!localStorage.getItem('userToken'));
    };
    const handleAuthChange = () => {
      setIsLoggedIn(!!localStorage.getItem('userToken'));
    };
    window.addEventListener('storage', handleStorage);
    window.addEventListener('auth-changed', handleAuthChange);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('auth-changed', handleAuthChange);
    };
  }, []);

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand" onClick={closeMenu}>
        <span className="brand-mark">
          <img src={logo} alt="Vix Algo Trading Store" className="logo" />
        </span>
        <span className="brand-text">
          <span className="brand-title">Vix Algo Trading</span>
          <span className="brand-subtitle">AUTO TRADING STORE</span>
        </span>
      </Link>
      <button
        ref={hamburgerRef}
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className="hamburger-icon"></span>
      </button>
      <div className={`navbar-content ${menuOpen ? 'open' : ''}`} ref={menuRef}>
        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search site..."
            className="search-input"
          />
          <button type="submit" className="search-button" onClick={closeMenu}>Search</button>
        </form>
        <div className="navbar-links">
          {!isLoggedIn && <Link to="/" className="navbar-link" onClick={closeMenu}>Home</Link>}
          <Link to="/products" className="navbar-link" onClick={closeMenu}>Products</Link>
          <Link to="/tester" className="navbar-link" onClick={closeMenu}>Builder</Link>
          {/* Importing an EA lives inside Signals, next to Deploy — it is the same job (put a
              strategy live), so it belongs beside it rather than as its own destination. */}
          <Link to="/signals" className="navbar-link" onClick={closeMenu}>Signals</Link>
          <Link to="/community" className="navbar-link" onClick={closeMenu}>Community</Link>
          <Link to="/faq" className="navbar-link" onClick={closeMenu}>FAQ</Link>
          {isLoggedIn ? (
            <>
              <Link to="/dashboard?tab=support" className="navbar-link" onClick={closeMenu}>Support</Link>
              <Link to="/dashboard?tab=purchases" className="navbar-link" onClick={closeMenu}>Purchases</Link>
              <Link to="/dashboard" className="navbar-link cta" onClick={closeMenu}>Dashboard</Link>
            </>
          ) : (
            <>
              <Link to="/redownload" className="navbar-link" onClick={closeMenu}>Re-download</Link>
              <Link to="/contact-us" className="navbar-link" onClick={closeMenu}>Contact</Link>
              <Link to="/login" className="navbar-link cta" onClick={closeMenu}>Sign In</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

